import { HiCursorClick } from "react-icons/hi";
import keyboardLogo from "../../medias/images/keyboard-logo.png";
import "./Productivity.css";

function Productivity(props) {
  const getBackgroundColor = () => {
    let color, productivity = props.productivityType;
    if (productivity == "productive") {
      color = "#3CBE52";
    } else if (productivity == "overtime"){
      color = "#fcd257"
    }else if (productivity == "otDiscard") {
      color = "#C34D57";
    } else if (productivity == "markAsActive") {
      color = "#F1C40F";
    } else if (productivity == "manualTime") {
      color = "#5669E1";
    }
    else if (productivity == "idle"){
      color = "#808080";
    }else{
      color = "#802112";
    }

    return color;
  };

  return (
    <div className="productivityCard">
      <div
        className="productivityType"
        style={{ backgroundColor: getBackgroundColor() }}>
        {props.productivityType}
      </div>
      
      <div className="settings">
        <div className="mouse">
          <span>{props.mouse}</span>
          <HiCursorClick />
        </div>
        <div className="keys">
          <span>{props.keys}</span>
          <img src={keyboardLogo} alt="keystrokes" />
        </div>
        <div className="work-description" title={props.project}>{props.project}</div>
      </div>
    </div>
  );
}

export default Productivity;
